'use client'

import { ChevronDown, Percent, Search } from 'lucide-react'
import { useState } from 'react'
import { useRouter } from 'next/navigation'
import HSChapterFilter from '../HsSearch/HSChapterFilter'
import HSTaxFilter from '../HsSearch/HSTaxFilter'
import { SearchInputWithHistory } from '@/modules/shared/components/SearchInputWithHistory'

const stats = [
  { value: '12,000+', label: 'Mã HS' },
  { value: '17+', label: 'Hiệp định FTA' },
  { value: '130+', label: 'Chính sách mặt hàng' },
  { value: '4+', label: 'Thuế nhập khẩu bổ sung và công cụ tính thuế  ' },
]

export default function HeroSearchSection() {
  const router = useRouter()
  const [searchValue, setSearchValue] = useState('')
  const [selectedChapters, setSelectedChapters] = useState<number[]>([])
  const [selectedTaxTypes, setSelectedTaxTypes] = useState<string[]>([])

  const handleSearch = (value: string) => {
    const params = new URLSearchParams()

    if (value.trim() !== '') {
      params.set('q', value.trim())
    }
    if (selectedChapters.length > 0) {
      params.set('chapterIds', selectedChapters.join(','))
    }
    if (selectedTaxTypes.length > 0) {
      params.set('taxTypes', selectedTaxTypes.join(','))
    }

    if (params.toString()) {
      router.push(`/ket-qua-tra-cuu-ma-hs?${params.toString()}`)
    }
  }

  const handleSubmit = (e?: React.FormEvent) => {
    e?.preventDefault()
    handleSearch(searchValue)
  }

  const handleSearchChange = (value: string) => {
    setSearchValue(value)
  }

  // Skip validation when filters are selected
  const hasFilters = selectedChapters.length > 0 || selectedTaxTypes.length > 0

  return (
    <section className="mb-12">
      <div className="hero-search-enhanced" id="search-hs">
        <div className="search-header-badge">
          <Search size={14} />
          <span>TRA CỨU MÃ HS</span>
        </div>
        <h1 className="hero-title-enhanced">
          Tra cứu mã HS - Biểu thuế xuất nhập khẩu 2026
        </h1>
        <p className="hero-subtitle-enhanced">
          Tìm kiếm nhanh mã HS, thuế suất nhập khẩu và thông tin pháp lý về mã
          HS
        </p>
        <div className="search-container-enhanced">
          <form onSubmit={handleSubmit} className="search-wrapper-enhanced">
            <SearchInputWithHistory
              value={searchValue}
              onChange={handleSearchChange}
              onSearch={handleSearch}
              placeholder="Nhập mã HS, hoặc mô tả bằng tiếng Việt hoặc tiếng Anh..."
              variant="hero"
              className="w-full"
              storageKey="hs-search-history"
              skipValidation={hasFilters}
            />
          </form>
          {/* Filter Buttons */}
          <div className="search-filters-enhanced">
            <div>
              <HSChapterFilter
                selectedChapters={selectedChapters}
                setSelectedChapters={setSelectedChapters}
              />
            </div>
            {/* <button type="button" className="filter-button">
              <Percent size={16} />
              <span>Thuế nhập khẩu</span>
              <ChevronDown size={14} className="chevron" />
            </button> */}
            <HSTaxFilter
              setSelectedTaxTypes={setSelectedTaxTypes}
              selectedTaxTypes={selectedTaxTypes}
            />
          </div>
        </div>
      </div>
      <div className="mini-stats-section">
        <div className="mini-stats-grid p-6 rounded-2xl">
          {stats.map((stat, index) => (
            <div key={index} className="mini-stat-card cl-card-border">
              <div className="mini-stat-value">{stat.value}</div>
              <div className="mini-stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
